import React from 'react';
import { useTranslation } from 'react-i18next';
import Users from '@/icons/Users';
import PawPrint from '@/icons/PawPrint';

export type FilterType = 'all' | 'people' | 'pets';

interface FamilyMembersFilterButtonsProps {
  currentFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  peopleCount: number;
  petsCount: number;
}

const FamilyMembersFilterButtons: React.FC<FamilyMembersFilterButtonsProps> = ({
  currentFilter,
  onFilterChange,
  peopleCount,
  petsCount
}) => {
  const { t } = useTranslation('screens');

  return (
    <div className="list-seg" role="tablist" aria-label={t('filters.filterByType')}>
      <button
        type="button"
        role="tab"
        aria-selected={currentFilter === 'people'}
        className={`list-seg__btn${currentFilter === 'people' ? ' list-seg__btn--active' : ''}`}
        onClick={() => onFilterChange('people')}
      >
        <Users width={14} height={14} />
        {t('filters.people')}
        <span className="list-seg__count">{peopleCount}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={currentFilter === 'pets'}
        className={`list-seg__btn${currentFilter === 'pets' ? ' list-seg__btn--active' : ''}`}
        onClick={() => onFilterChange('pets')}
      >
        <PawPrint width={14} height={14} />
        {t('filters.pets')}
        <span className="list-seg__count">{petsCount}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={currentFilter === 'all'}
        className={`list-seg__btn${currentFilter === 'all' ? ' list-seg__btn--active' : ''}`}
        onClick={() => onFilterChange('all')}
      >
        {t('filters.all')}
        <span className="list-seg__count">{peopleCount + petsCount}</span>
      </button>
    </div>
  );
};

export default FamilyMembersFilterButtons;
